<template>

  <ag-grid class="ag-theme-balham ag-grid-instance" :class="{ 'checkbox-disabled': !selectionEnabled }"
    :columnDefs="columnDefs" :modules="modules" :frameworkComponents="frameworkComponents" :components="components"
    :gridOptions="gridOptions" :rowSelection="rowSelection" :suppressRowClickSelection="suppressRowClickSelection"
    :suppressMenuHide="true" :stopEditingWhenGridLosesFocus="true" @first-data-rendered="onFirstDataRendered"
    @selectionChanged="onSelectionChanged" @row-drag-end="draggingEnd" @grid-ready="onGridReady"></ag-grid>

</template>
<script>
// style="width: 100%; height: 430px;"
import Vue from "vue";

import "@ag-grid-community/all-modules/dist/styles/ag-grid.css";
import "@ag-grid-community/all-modules/dist/styles/ag-theme-balham.css";

import { AllCommunityModules } from "@ag-grid-community/all-modules";
import { AgGridVue } from "@ag-grid-community/vue";

import {
  vSelectCellEditor,
  optionsBunchCellEditor,
  optionsBunchCellRenderer,
  dateCellEditor
} from "./GridSubComponents/subComponents";

import { t } from 'i18next'

export default {
  name: "GridComponent",
  props: ["grid", "dragging_end"],
  components: {
    "ag-grid": AgGridVue
  },
  created() {
    this.gridOptions.onCellValueChanged = this.cellValueChangedProxy;
    this.gridOptions.rowClass = 'default-row-style';
    this.gridOptions.onCellEditingStarted =
      this.grid.onCellEditingStarted || (() => { });
    this.gridOptions.defaultColDef = this.grid.defaultColDef || {};
    this.columnDefs = this.grid.columnDefs || [];
    this.rowSelection = this.grid.rowSelection || 'multiple';
    this.suppressRowClickSelection = this.grid.suppressRowClickSelection || false;
    this.prepareColumnsDefs();
    this.gridOptions.onRowClicked = this.grid.onRowClicked;
    this.gridOptions.onRowDoubleClicked = this.grid.onRowDoubleClicked;
    if (this.grid.lazyLoad !== true) {
      this.updateRowData();
    }
    this.setRowChangedListener();
    this.setGridFunctions();
    if (this.grid.getRowStyle) {
      this.gridOptions.getRowStyle = this.grid.getRowStyle;
    }
    if (this.grid.resizeStyle !== undefined) {
      this.resizeStyle = this.grid.resizeStyle;
    }

    this._rowData = []; // private prop
  },
  data: () => {
    return {
      // rowData: [],
      resizeStyle: 'auto',
      columnDefs: [],
      rowSelection: "multiple",
      suppressRowClickSelection: false,
      modules: AllCommunityModules,
      gridOptions: {
        localeText: {
          // for filter panel
          page: t('page'),
          more: t('more'),
          to: t('to'),
          of: t('of'),
          next: t('next'),
          last: t('last'),
          first: t('first'),
          previous: t('previous'),
          loadingOoo: t('loadingOoo'),

          // for set filter
          selectAll: t('selectAll'),
          searchOoo: t('searchOoo'),
          blanks: t('blanks'),

          // for number filter and text filter
          filterOoo: t('filterOoo'),
          applyFilter: t('applyFilter'),
          equals: t('equals'),
          notEqual: t('notEqual'),

          // for number filter
          lessThan: t('lessThan'),
          greaterThan: t('greaterThan'),
          lessThanOrEqual: t('lessThanOrEqual'),
          greaterThanOrEqual: t('greaterThanOrEqual'),
          inRange: t('in_between'),

          // for text filter
          contains: t('contains'),
          notContains: t('notContains'),
          startsWith: t('startsWith'),
          endsWith: t('endsWith'),

          // filter conditions
          andCondition: t('and'),
          orCondition: t('or'),

          noRowsToShow: t('no_records_found')
        }
      },
      frameworkComponents: {
        vSelectCellEditor: vSelectCellEditor,
        optionsBunchCellEditor: optionsBunchCellEditor,
        dateCellEditor: dateCellEditor
      },
      components: {
        optionsBunchCellRenderer
      },
      selectionEnabled: true,
    };
  },
  beforeMount() { },
  beforeDestroy() {
    delete this._rowData;
    // delete this.gridOptions;
  },
  methods: {
    draggingEnd: function (e) {
      if (this.dragging_end) {
        this.dragging_end(e);
      }
    },
    onSelectionChanged(params) {
      this.triggerCheckedRowsEvent();

      if (this.grid.onSelectionChanged instanceof Function) {
        this.grid.onSelectionChanged(params);
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;

      // Agora que a API existe, já pode inicializar se precisar
      this.grid.gridControl = this.gridApi;
      this.grid.advancedOptions = this.gridOptions;

      if (!this.loadingTimeoutID && this.grid.dataSource && this.grid.lazyLoad !== true) {
        this.loadingTimeoutID = setTimeout(() => {
          if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
          }
        }, 250);
      }
    },
    /**
     * Fit grid size to container div.
     */
    onFirstDataRendered: function (e) {
      if (this.resizeStyle === 'auto' || this.resizeStyle === 'auto-no-header') {
        const skipHeader = this.resizeStyle === 'auto-no-header';
        let allColumnIds = e.columnApi.getAllColumns().map(c => c.colId);
        e.columnApi.autoSizeColumns(allColumnIds, skipHeader);
      } else if (this.resizeStyle === 'fit') {
        e.api.sizeColumnsToFit();
      }
    },

    /**
     * If grid has a dataSource property, calls the
     * function and set data into rowData.
     */
    updateRowData: function () {
      if (!this.grid.dataSource) {
        return;
      }

      this.triggerIsAddingNewRowEvent(false);

      if (!this.loadingTimeoutID && this.gridApi) {
        this.loadingTimeoutID = setTimeout(() => {
          if (this.gridApi) {
            this.gridApi.showLoadingOverlay();
          }
        }, 250);
      }

      return this.grid
        .dataSource(this.grid.dataSourceFilter || {})
        .then(data => {
          this.setRowData(data);

          if (this.loadingTimeoutID) {
            clearTimeout(this.loadingTimeoutID);
            this.loadingTimeoutID = null;

            if (this.gridApi) {
              // this.gridApi.hideOverlay();
              // if (!data || data.length === 0) this.gridApi.showNoRowsOverlay();
            }
          }

          this.triggerCheckedRowsEvent(false);
          return data;
        })
        .catch(e => {
          if (this.loadingTimeoutID) {
            clearTimeout(this.loadingTimeoutID);
            this.loadingTimeoutID = null;

            if (this.gridApi) {
              // this.gridApi.hideOverlay();
              // this.gridApi.showNoRowsOverlay();
            }
          }

          this.triggerCheckedRowsEvent(false);
          throw e;
        });
    },

    /**
     * Prepare all columns properties.
     * Fix select dropdown overflow.
     * Call select options function and set data on it.
     */
    prepareColumnsDefs: function () {
      this.columnDefs.forEach(column => {
        if (column.cellEditor == "vSelectCellEditor") {
          this.fixVSelectOverflow(column);
        }

        if (column.cellEditorParams) {
          // column.cellEditorParams.jumpNextEditableCell = this.jumpNextEditableCell;
          column.cellEditorParams.jumpNextEditableCell = () => { };

          if (column.cellEditorParams.optionsDataSource) {
            this.setSelectOptions(column);
          }
        }

        if (column.filterParams) {
          column.filterParams.newRowsAction = 'keep';
          column.filterParams.debounceMs = '1000';
        } else {
          column.filterParams = {
            newRowsAction: 'keep',
            debounceMs: '1000'
          }
        }
      });
    },

    /**
     * Set select/bunch options data.
     */
    setSelectOptions: function (column) {
      if (
        column.cellEditorParams.optionsDataSource &&
        column.cellEditorParams.optionsDataSource instanceof Function
      ) {
        column.cellEditorParams.options = {};

        let _optionsPromise = column.cellEditorParams.optionsDataSource;
        _optionsPromise().then(function (data) {
          column.cellEditorParams.options = data;
        });
      }
    },

    /**
     * Fix select dropdown overflow.
     */
    fixVSelectOverflow: function (column) {
      if (column.cellClass) {
        let newCellClass = ["overflow-visible"].concat(column.cellClass);
        column.cellClass = newCellClass;
      } else {
        column.cellClass = ["overflow-visible"]
      }
    },

    /**
     * Setup a changed function to set 'changed'
     * property on row.
     */
    setRowChangedListener: function () {
      let _bkpOnChangeFunc = this.gridOptions.onCellValueChanged;

      this.gridOptions.onCellValueChanged = (params) => {
        const changedRowIndex = params.rowIndex;
        const changedRow = this.gridOptions.api.getRowNode(changedRowIndex);

        if (changedRow) {
          changedRow.changed = true;
        }

        if (_bkpOnChangeFunc) {
          _bkpOnChangeFunc(params);
        }
      };
    },

    /**
     * Set all grid external functions
     */
    setGridFunctions: function () {
      this.grid.getChangedRows = this.getChangedRows;
      this.grid.clearChangedRows = this.clearChangedRows;
      this.grid.reloadData = this.updateRowData;
      this.grid.addNewRowToGrid = this.addNewRowToGrid;
      this.grid.deleteCheckedRows = this.deleteCheckedRows;
      this.grid.disableSelection = this.disableSelection;
      this.grid.enableSelection = this.enableSelection;
      this.grid.getRowData = this.getRowData;
      this.grid.setRowData = this.setRowData;
      this.grid.updateRowNode = this.updateRowNode;
      this.grid.triggerIsAddingNewRowEvent = this.triggerIsAddingNewRowEvent;
    },

    /**
     * Return changed rows nodes to grid container.
     */
    getChangedRows: function () {
      let changedRows = this.gridOptions.api
        .getModel()
        .rowsToDisplay.filter(row => row.changed);
      return changedRows && changedRows.length
        ? changedRows.map(row => row.data)
        : [];
    },

    clearChangedRows: function () {
      this.gridOptions.api.forEachNode(node => {
        node.changed = false;
      });
    },

    disableSelection: function () {
      this.gridOptions.suppressRowClickSelection = true;
      this.selectionEnabled = false;
    },
    enableSelection: function () {
      this.gridOptions.suppressRowClickSelection = false;
      this.selectionEnabled = true;
    },
    /**
     * adds a new row to the top of the grid with the
     *  __is_new_row property set to true
     */
    addNewRowToGrid: function (autoFocus = true, singleRow = true, disableSelection = true) {
      this.$emit('update:isAddingNewRow', true);
      let data = this._rowData;
      if (singleRow && data.length && data[0].__is_new_row) {
        return; //break
      }
      data.unshift({ __is_new_row: true });
      this.setRowData(data);
      if (autoFocus) {
        setTimeout(
          function () {
            this.gridOptions.api.startEditingCell({
              rowIndex: 0,
              colKey: this.columnDefs[0].field
            });
          }.bind(this),
          220
        );
      }
      if (disableSelection) {
        this.disableSelection();
      }
    },
    deleteCheckedRows: function (deleterFunction) {
      let advancedOptions = this.gridOptions;
      let selectedRows = advancedOptions.api.getSelectedRows();
      let rowData = this._rowData;
      if (selectedRows.length > 0) {
        return deleterFunction(selectedRows).then(() => {
          let newRowData = rowData.filter(r => !selectedRows.includes(r));
          this.setRowData(newRowData);
          this.triggerCheckedRowsEvent();
        });
      } else {
        return Promise.reject({ error: t('no_record_selected') });
      }
    },

    triggerCheckedRowsEvent: function (val) {
      let newValue = typeof val === "boolean" ? val : this.gridOptions.api.getSelectedRows().length > 0;
      this.$emit('update:hasCheckedRows', newValue);
    },
    triggerIsAddingNewRowEvent: function (val) {
      this.$emit('update:isAddingNewRow', val);
    },

    getRowData: function () {
      return this._rowData;
    },

    // under watch for possible memory leaks
    setRowData: function (rowData, { setIsAddingNewRow } = {}) {
      this._rowData = rowData;
      if (this._rowData && this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.setRowData(this._rowData);
      }
      setIsAddingNewRow !== undefined && this.triggerIsAddingNewRowEvent(setIsAddingNewRow);
    },
    updateRowNode: function ({ data, node, setIsAddingNewRow, force = false } = {}) {
      const { rowIndex } = node;
      this._rowData[rowIndex] = data;
      node.data = data;
      if (this._rowData && this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.refreshCells({ rowNodes: [node], force });
      }
      setIsAddingNewRow !== undefined && this.triggerIsAddingNewRowEvent(setIsAddingNewRow);
    },
    cellValueChangedProxy: function (p) {
      if ((p.oldValue !== p.newValue /*|| p.data.__is_new_row*/) && this.grid.onCellValueChanged) {
        this.grid.onCellValueChanged(p);
      }
    },

    _isColumnEditable(colData) {
      const isEditable = colData.hasOwnProperty('editable') ? colData.editable : this.gridOptions.defaultColDef.editable;
      const preventAutoFocusEditors = ["optionsBunchCellEditor"];
      return isEditable && !preventAutoFocusEditors.includes(colData.cellEditor);
    },
    /**
     * Jump to next editable cell on line
     *
     * @param {Number} rowIndex Index of current cell row.
     * @param {String} colKey Column 'field' property of current cell.
     */
    jumpNextEditableCell(rowIndex, colKey) {
      let nextEditableCell = false;
      let colKeyIndex = this.columnDefs.indexOf(this.columnDefs.find(col => col.field == colKey));
      let nextEditCol = undefined;
      const datasetSize = this._rowData.length;

      while (!nextEditableCell && rowIndex < datasetSize) {
        nextEditCol = this.columnDefs.find((col, index) => index > colKeyIndex && this._isColumnEditable(col));

        if (nextEditCol === undefined) {
          colKeyIndex = -1;
          rowIndex++;
        } else {
          nextEditableCell = {
            rowIndex,
            colKey: nextEditCol.field
          }
        }
      }

      nextEditableCell && this.gridOptions.api.startEditingCell(nextEditableCell);
    }
  }
};
</script>

<style lang="less">
@import (reference) url("../../assets/variables.less");

.options-bunch-cell-editor {
  height: 100%;
  width: 100%;
}


.ag-row ul {
  position: absolute;
  top: -80px;
  left: -3px;
}

/* Remove a estilização para os três primeiros .ag-row */
.ag-row:nth-child(-n+3) ul {
  position: static;
}

.ag-cell {



  &.open-select-above {
    .vs__dropdown-menu {
      bottom: 29px;
      top: unset;
    }
  }

  &.ag-cell-inline-editing {

    &.overflow-visible {
      overflow: visible;
    }


  }
}

.ag-grid-instance {

  &.checkbox-disabled {
    .ag-cell {
      .ag-selection-checkbox {
        pointer-events: none;
      }
    }
  }


  width: 100%;
  height: 430px;

  div.ag-header {
    background-color: @azul;


    .ag-header-cell {
      color: white;
    }
  }

  .default-row-style {
    &.ag-row-odd {
      background: rgba(196, 196, 196, 0.2);

      &:hover {
        background: rgba(196, 196, 196, 0.5);
      }

      &.ag-row-selected {
        background: rgb(175, 218, 245);
      }
    }
  }
}

body .vs__dropdown-menu.grid-v-select-dropdown {
  font-size: 12px;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  line-height: 1.25;
}

body .vs__dropdown-menu.grid-v-select-dropdown .vs__dropdown-option {
  padding: 6px 10px;
  white-space: normal;
  word-break: break-word;
}
</style>
